<template>
  <el-form ref="form" :model="formData" :rules="rules" size="small">
    <el-row :gutter="20">
      <el-col :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 12 }">
        <el-form-item
          :label="$l('form_label_category') || '分类'"
          prop="masterCategoryCode"
        >
          <dict-select
            style="width: 100%"
            :placeholder="$l('form_label_category') || '分类'"
            filterable
            clearable
            v-model="formData.masterCategoryCode"
            size="medium"
            url="/digitalCenter/common/dict/masterCategory"
            disabled
          >
          </dict-select>
        </el-form-item>
      </el-col>
      <el-col :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 12 }">
        <el-form-item
          :label="$l('form_label_column_type') || '字段类型'"
          prop="resInputColumnType"
        >
          <el-select
            style="width: 100%"
            @change="changeColumn"
            v-model="formData.resInputColumnType"
            :disabled="disabled"
            :placeholder="$l('form_label_column_type') || '字段类型'"
            size="medium"
            filterable
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 12 }">
        <el-form-item
          :label="$l('form_label_column_name') || '字段名称'"
          prop="resInputColumnDisplay"
        >
          <el-input
            size="medium"
            v-model="formData.resInputColumnDisplay"
            clearable
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 12 }">
        <el-form-item
          :label="$l('form_label_attribute_type') || '属性类型'"
          prop="resInputColumnName"
        >
          <dict-select
            size="medium"
            v-if="formData.resInputColumnType == 'select'"
            :disabled="disabled"
            v-model="formData.resInputColumnName"
            filterable
            clearable
            url="/digitalCenter/common/dict/researchDict"
            :placeholder="$l('form_label_attribute_type') || '属性类型'"
            style="width: 100%"
          ></dict-select>
          <el-input
            size="medium"
            v-else-if="formData.resInputColumnType === 'input'"
            v-model="formData.resInputColumnName"
            :placeholder="$l('form_label_attribute_type') || '属性类型'"
            clearable
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 12 }">
        <el-form-item
          :label="$l('form_label_is_visiable') || '是否显示'"
          prop="isVisible"
        >
          <el-radio-group
            size="medium"
            style="width: 100%"
            :disabled="disabled"
            v-model="formData.isVisible"
          >
            <el-radio label="Y">{{
              $l('form_radio_label_yes') || '是'
            }}</el-radio>
            <el-radio label="N">{{
              $l('form_radio_label_no') || '否'
            }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 12 }">
        <el-form-item
          :label="$l('form_label_is_multiselect') || '是否多选'"
          prop="isMultiselect"
        >
          <el-radio-group
            size="medium"
            style="width: 100%"
            :disabled="disabled"
            v-model="formData.isMultiselect"
          >
            <el-radio label="Y">{{
              $l('form_radio_label_yes') || '是'
            }}</el-radio>
            <el-radio label="N">{{
              $l('form_radio_label_no') || '否'
            }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 12 }">
        <el-form-item
          :label="$l('form_label_is_required') || '是否必输项'"
          prop="isRequired"
        >
          <el-radio-group
            size="medium"
            style="width: 100%"
            :disabled="disabled"
            v-model="formData.isRequired"
          >
            <el-radio label="Y">{{
              $l('form_radio_label_yes') || '是'
            }}</el-radio>
            <el-radio label="N">{{
              $l('form_radio_label_no') || '否'
            }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 12 }">
        <el-form-item
          :label="$l('form_label_sortorder') || '排序顺序'"
          prop="sortOrder"
        >
          <el-input
            size="medium"
            v-model="formData.sortOrder"
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col v-if="formData.resTemplateCode">
        <div style="font-size: 14px; color: #606266">
          <span
            >Create：{{ formData.createByName }} at
            {{ formData.createDate }}</span
          >
          <el-divider direction="vertical"></el-divider>
          <span
            >Modify：{{ formData.modifyByName }} at
            {{ formData.modifyDate }}</span
          >
        </div>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    createDateVisible: Boolean,
    resTemplateCode: String,
    masterCategoryCode: String,
    params: { type: Object, default: () => {} },
  },
  data() {
    return {
      formData: {
        isVisible: 'Y',
        masterCategoryCode: this.masterCategoryCode,
        resInputColumnType: 'input',
      },
      rules: {
        masterCategoryCode: [
          {
            required: true,
            message: this.$l('form_rule_message_category') || '请选择分类',
            trigger: 'blur',
          },
        ],
        resInputColumnName: [
          {
            required: true,
            message:
              this.$l('form_rule_message_attribute_type') || '请输入属性字典',
            trigger: 'blur',
          },
        ],
        resInputColumnDisplay: [
          {
            required: true,
            message:
              this.$l('form_rule_message_column_name') || '请输入字段名称',
            trigger: 'blur',
          },
        ],
        resInputColumnType: [
          {
            required: true,
            message:
              this.$l('form_rule_message_column_type') || '请选择字段类型',
            trigger: 'blur',
          },
        ],
        isVisible: [
          {
            required: true,
            message:
              this.$l('form_rule_message_visible_status') || '请选择显示状态',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.resTemplateCode) return

      this.$api
        .detailResearchInputTemplateApi({
          resTemplateCode: this.resTemplateCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      this.loadingOpen()
      this.$api
        .saveResearchInputTemplateApi(this.formData)
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存',
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          }
        })
    },
    //改变选择框
    changeColumn() {
      this.formData.resInputColumnName = ''
    },
  },
}
</script>
